import { useGetProfile } from 'hooks/api/login';
import { useRole } from 'hooks/common/useRole';
import Link from 'components/Link';
import messages from './LoginUser.messages';
import styles from './LoginUser.module.css';

const LoginUser = (): JSX.Element => {
  const { isAdmin } = useRole();
  const { data: profile } = useGetProfile();

  const onUserLinkClick = (): void => {
    if (isAdmin) return;
    // NOTE: Disabled in ETZ-2825. Need to check actuality. Related to 'Role User'
    // toAuthUserRoleUser(profile?.id.toString());
  };

  return (
    <p className={styles.loginUser}>
      {messages.loginAs}
      <br />
      <Link text={profile?.displayName ?? ''} onClick={onUserLinkClick} />
    </p>
  );
};

export default LoginUser;
